import type { FC, ReactNode } from "react";

interface HeaderIconProps {
  icon: ReactNode;
  color?:
    | "primary"
    | "success"
    | "warning"
    | "danger"
    | "violet"
    | "emerald"
    | "sky"
    | "amber"
    | "rose";
  className?: string;
}

export const HeaderIcon: FC<HeaderIconProps> = ({
  icon,
  color = "primary",
  className = "",
}) => {
  const colorClasses = {
    amber:
      "border-amber-500/30 bg-amber-500/10 text-amber-600 dark:border-amber-400/30 dark:bg-amber-400/10 dark:text-amber-400",
    danger:
      "border-rose-500/30 bg-rose-500/10 text-rose-600 dark:border-rose-400/30 dark:bg-rose-400/10 dark:text-rose-400",
    emerald:
      "border-emerald-500/30 bg-emerald-500/10 text-emerald-600 dark:border-emerald-400/30 dark:bg-emerald-400/10 dark:text-emerald-400",
    primary:
      "border-arti-primary/20 bg-arti-primary/10 text-arti-primary dark:border-arti-secondary/30 dark:bg-arti-secondary/10 dark:text-arti-secondary",
    rose: "border-rose-500/30 bg-rose-500/10 text-rose-600 dark:border-rose-400/30 dark:bg-rose-400/10 dark:text-rose-400",
    sky: "border-slate-300 bg-slate-100 text-slate-600 dark:border-slate-700 dark:bg-slate-900/80 dark:text-slate-300",
    success:
      "border-emerald-500/30 bg-emerald-500/10 text-emerald-600 dark:border-emerald-400/30 dark:bg-emerald-400/10 dark:text-emerald-400",
    violet:
      "border-violet-500/30 bg-violet-500/10 text-violet-600 dark:border-violet-400/30 dark:bg-violet-400/10 dark:text-violet-400",
    warning:
      "border-amber-500/30 bg-amber-500/10 text-amber-600 dark:border-amber-400/30 dark:bg-amber-400/10 dark:text-amber-400",
  };

  return (
    <div
      className={`rounded-none border p-2 shadow-sm ${colorClasses[color]} ${className}`}
    >
      {icon}
    </div>
  );
};
